
export default {
  props: ["element","swipeKey"],
  data() {
    return {
      
      touchstartX: 0,
      touchendX: 0,
      lock: false,
      pointerDown: false,
      temporary: this.element?.temporary,
      padding: this.element?.padding,
      threshold: this.element?.threshold,
    };
  },
  mounted() {
    if (process.browser) {
      document.onpointerup = (_) => (this.pointerDown = false);
    }
  },
  methods: {
    handle(e, end) {
      let screenX = e.type.includes("pointer")
        ? e.screenX
        : e.changedTouches[0].screenX;
      if (end) {
        if (this.temporary) {
          setTimeout(() => {
            this.reset();
          }, 300);
        }
        this.touchendX = screenX;
        this.pointerDown = false;
        // document.body.style.overflowY = "unset";
        // document.body.style.paddingRight = '0px';
      } else {
        this.touchstartX = screenX;
        this.pointerDown = true;
      }
    },
    move(e) {
      if (this.lock || (e.type.includes("pointer") && !this.pointerDown)) {
        return;
      }
      let screenX = e.type.includes("pointer")
        ? e.screenX
        : e.changedTouches[0].screenX;
      let left = document.querySelector(".swipe-left-"+this.swipeKey);
      let right = document.querySelector(".swipe-right-"+this.swipeKey);
      let center = document.querySelector(".swipe-center-"+this.swipeKey);
      let centerWidth = center.clientWidth * (this.threshold / 100);
      let max = e.target.clientWidth - (this.padding || 0);
      let size = e.target.clientWidth * (this.threshold / 100);
      let distance = screenX - this.touchstartX;
      let direction = "right";
      if (distance < 0) {
        distance = Math.abs(distance);
        direction = "left";
      }
      if (distance > 80) {
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;
        // document.body.style.paddingRight = `${scrollbarWidth}px`;
        // document.body.style.overflowY = "hidden";
      }
      if (distance > max || distance > size) {
        distance = max;
      }
      if (distance < 80) {
        return;
      }
      if (this.temporary) {
        this.lock = true;
        setTimeout(() => {
          if (direction == "left") {
            this.$emit("actionLeft");
          }
          if (direction == "right") {
            this.$emit("actionRight");
          }
          setTimeout(() => {
            this.reset();
          }, 500);
        }, 500);
      }
      if (screenX > this.touchstartX) {
        right.style.transform = `translateX(100%)`;
        right.style.zIndex = 1;
        right.style.opacity = 0;
        left.style.zIndex = 2;
        left.style.opacity = 1;
        left.style.transform = `translateX(0%)`;
      } else {
        left.style.transform = `translateX(-100%)`;
        left.style.zIndex = 1;
        left.style.opacity = 0;
        right.style.zIndex = 2;
        right.style.opacity = 1;
        right.style.transform = `translateX(${centerWidth}px)`;
      }
      center.style.transform = `translate3d(${
        direction == "left" ? `-${centerWidth}` : centerWidth
      }px,0px,0px)`;
    },
    reset(e) {
      let centerWidth =
        document.querySelector(".swipe-center").clientWidth *
        (this.threshold / 100);
      let left = document.querySelector(".swipe-left-"+this.swipeKey);
      let right = document.querySelector(".swipe-right-"+this.swipeKey);
      let center = document.querySelector(".swipe-center-"+this.swipeKey);
      left.style.transform = ``;
      right.style.transform = ``;
      left.style.opacity = 0;
      right.style.opacity = 0;
      center.style.transform = "";
      this.lock = false;
    },
  },
};
